const features = [
  {
    icon: 'ri-hd-line',
    title: '高清画质',
    desc: '支持1080P至4K超高清画质播放，根据网络环境智能适配最佳清晰度，畅享影院级观影体验。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速加载',
    desc: '采用先进的视频加速与CDN分发技术，播放流畅不缓冲，无论何时何地都能快速开始观影。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全无忧',
    desc: '平台所有内容均经过严格审核，无病毒木马，无需注册即可观看，保护您的隐私安全。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '西瓜视频免费资源和91在线视频内容每日定时更新，热播剧集综艺准时上线，追剧不等待。',
  },
  {
    icon: 'ri-device-line',
    title: '多端同步',
    desc: '支持电脑、手机、平板多设备无缝切换，观影记录自动同步，随时随地接续上次播放进度。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-500/10 border border-accent-500/20 mb-4">
            <span className="text-xs text-accent-400 whitespace-nowrap">为什么选择我们</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-50 mb-3">特色优势</h2>
          <p className="text-sm text-foreground-400 max-w-xl mx-auto">
            69视频致力于打造极致的在线观影体验，五大核心优势让你放心追剧
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {features.map((f) => (
            <div key={f.title} className="group flex flex-col items-center text-center p-6 bg-background-200/40 rounded-xl hover:bg-background-200 transition-colors cursor-pointer">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/10 mb-4 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${f.icon} text-2xl text-primary-400`}></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-200 mb-2 whitespace-nowrap">{f.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}